import React, { useState, useEffect } from "react";
import Dropdown from "@/components/ui/Dropdown";
import { Building, MapPin, Globe } from "lucide-react";
import * as Yup from "yup";
import { companiesService } from "@/services/companiesService";

// Country codes list
const COUNTRIES = [
  { code: "+93", name: "Afghanistan" },
  { code: "+355", name: "Albania" },
  { code: "+213", name: "Algeria" },
  { code: "+376", name: "Andorra" },
  { code: "+244", name: "Angola" },
  { code: "+1-268", name: "Antigua and Barbuda" },
  { code: "+54", name: "Argentina" },
  { code: "+374", name: "Armenia" },
  { code: "+61", name: "Australia" },
  { code: "+43", name: "Austria" },
  { code: "+994", name: "Azerbaijan" },
  { code: "+1-242", name: "Bahamas" },
  { code: "+973", name: "Bahrain" },
  { code: "+880", name: "Bangladesh" },
  { code: "+1-246", name: "Barbados" },
  { code: "+375", name: "Belarus" },
  { code: "+32", name: "Belgium" },
  { code: "+501", name: "Belize" },
  { code: "+229", name: "Benin" },
  { code: "+975", name: "Bhutan" },
  { code: "+591", name: "Bolivia" },
  { code: "+387", name: "Bosnia and Herzegovina" },
  { code: "+267", name: "Botswana" },
  { code: "+55", name: "Brazil" },
  { code: "+673", name: "Brunei" },
  { code: "+359", name: "Bulgaria" },
  { code: "+226", name: "Burkina Faso" },
  { code: "+257", name: "Burundi" },
  { code: "+238", name: "Cabo Verde" },
  { code: "+855", name: "Cambodia" },
  { code: "+237", name: "Cameroon" },
  { code: "+1", name: "Canada" },
  { code: "+236", name: "Central African Republic" },
  { code: "+235", name: "Chad" },
  { code: "+56", name: "Chile" },
  { code: "+86", name: "China" },
  { code: "+57", name: "Colombia" },
  { code: "+269", name: "Comoros" },
  { code: "+242", name: "Congo" },
  { code: "+506", name: "Costa Rica" },
  { code: "+385", name: "Croatia" },
  { code: "+53", name: "Cuba" },
  { code: "+357", name: "Cyprus" },
  { code: "+420", name: "Czech Republic" },
  { code: "+243", name: "Democratic Republic of the Congo" },
  { code: "+45", name: "Denmark" },
  { code: "+253", name: "Djibouti" },
  { code: "+1-767", name: "Dominica" },
  { code: "+1-809", name: "Dominican Republic" },
  { code: "+593", name: "Ecuador" },
  { code: "+20", name: "Egypt" },
  { code: "+503", name: "El Salvador" },
  { code: "+240", name: "Equatorial Guinea" },
  { code: "+291", name: "Eritrea" },
  { code: "+372", name: "Estonia" },
  { code: "+251", name: "Ethiopia" },
  { code: "+679", name: "Fiji" },
  { code: "+358", name: "Finland" },
  { code: "+33", name: "France" },
  { code: "+241", name: "Gabon" },
  { code: "+220", name: "Gambia" },
  { code: "+995", name: "Georgia" },
  { code: "+49", name: "Germany" },
  { code: "+233", name: "Ghana" },
  { code: "+30", name: "Greece" },
  { code: "+1-473", name: "Grenada" },
  { code: "+502", name: "Guatemala" },
  { code: "+224", name: "Guinea" },
  { code: "+245", name: "Guinea-Bissau" },
  { code: "+592", name: "Guyana" },
  { code: "+509", name: "Haiti" },
  { code: "+504", name: "Honduras" },
  { code: "+36", name: "Hungary" },
  { code: "+354", name: "Iceland" },
  { code: "+91", name: "India" },
  { code: "+62", name: "Indonesia" },
  { code: "+98", name: "Iran" },
  { code: "+964", name: "Iraq" },
  { code: "+353", name: "Ireland" },
  { code: "+972", name: "Israel" },
  { code: "+39", name: "Italy" },
  { code: "+1-876", name: "Jamaica" },
  { code: "+81", name: "Japan" },
  { code: "+962", name: "Jordan" },
  { code: "+7", name: "Kazakhstan" },
  { code: "+254", name: "Kenya" },
  { code: "+686", name: "Kiribati" },
  { code: "+850", name: "North Korea" },
  { code: "+82", name: "South Korea" },

  { code: "+965", name: "Kuwait" },
  { code: "+996", name: "Kyrgyzstan" },
  { code: "+856", name: "Laos" },
  { code: "+371", name: "Latvia" },
  { code: "+961", name: "Lebanon" },
  { code: "+266", name: "Lesotho" },
  { code: "+231", name: "Liberia" },
  { code: "+218", name: "Libya" },
  { code: "+423", name: "Liechtenstein" },
  { code: "+370", name: "Lithuania" },
  { code: "+352", name: "Luxembourg" },
  { code: "+261", name: "Madagascar" },
  { code: "+265", name: "Malawi" },
  { code: "+60", name: "Malaysia" },
  { code: "+960", name: "Maldives" },
  { code: "+223", name: "Mali" },
  { code: "+356", name: "Malta" },
  { code: "+692", name: "Marshall Islands" },
  { code: "+222", name: "Mauritania" },
  { code: "+230", name: "Mauritius" },
  { code: "+52", name: "Mexico" },
  { code: "+691", name: "Micronesia" },
  { code: "+373", name: "Moldova" },
  { code: "+377", name: "Monaco" },
  { code: "+976", name: "Mongolia" },
  { code: "+382", name: "Montenegro" },
  { code: "+212", name: "Morocco" },
  { code: "+258", name: "Mozambique" },
  { code: "+95", name: "Myanmar" },
  { code: "+264", name: "Namibia" },
  { code: "+674", name: "Nauru" },
  { code: "+977", name: "Nepal" },
  { code: "+31", name: "Netherlands" },
  { code: "+64", name: "New Zealand" },
  { code: "+505", name: "Nicaragua" },
  { code: "+227", name: "Niger" },
  { code: "+234", name: "Nigeria" },
  { code: "+47", name: "Norway" },
  { code: "+968", name: "Oman" },
  { code: "+92", name: "Pakistan" },
  { code: "+680", name: "Palau" },
  { code: "+507", name: "Panama" },
  { code: "+675", name: "Papua New Guinea" },
  { code: "+595", name: "Paraguay" },
  { code: "+51", name: "Peru" },
  { code: "+63", name: "Philippines" },
  { code: "+48", name: "Poland" },
  { code: "+351", name: "Portugal" },
  { code: "+974", name: "Qatar" },
  { code: "+40", name: "Romania" },
  { code: "+7", name: "Russia" },
  { code: "+250", name: "Rwanda" },
  { code: "+1-869", name: "Saint Kitts and Nevis" },
  { code: "+1-758", name: "Saint Lucia" },
  { code: "+1-784", name: "Saint Vincent and the Grenadines" },
  { code: "+685", name: "Samoa" },
  { code: "+378", name: "San Marino" },
  { code: "+239", name: "Sao Tome and Principe" },
  { code: "+966", name: "Saudi Arabia" },
  { code: "+221", name: "Senegal" },
  { code: "+381", name: "Serbia" },
  { code: "+248", name: "Seychelles" },
  { code: "+232", name: "Sierra Leone" },
  { code: "+65", name: "Singapore" },
  { code: "+421", name: "Slovakia" },
  { code: "+386", name: "Slovenia" },
  { code: "+677", name: "Solomon Islands" },
  { code: "+252", name: "Somalia" },
  { code: "+27", name: "South Africa" },
  { code: "+211", name: "South Sudan" },
  { code: "+34", name: "Spain" },
  { code: "+94", name: "Sri Lanka" },
  { code: "+249", name: "Sudan" },
  { code: "+597", name: "Suriname" },
  { code: "+268", name: "Eswatini" },
  { code: "+46", name: "Sweden" },
  { code: "+41", name: "Switzerland" },
  { code: "+963", name: "Syria" },
  { code: "+886", name: "Taiwan" },
  { code: "+992", name: "Tajikistan" },
  { code: "+255", name: "Tanzania" },
  { code: "+66", name: "Thailand" },
  { code: "+670", name: "Timor-Leste" },
  { code: "+228", name: "Togo" },
  { code: "+676", name: "Tonga" },
  { code: "+1-868", name: "Trinidad and Tobago" },
  { code: "+216", name: "Tunisia" },
  { code: "+90", name: "Turkey" },
  { code: "+993", name: "Turkmenistan" },
  { code: "+688", name: "Tuvalu" },
  { code: "+256", name: "Uganda" },
  { code: "+380", name: "Ukraine" },
  { code: "+971", name: "United Arab Emirates" },
  { code: "+44", name: "United Kingdom" },
  { code: "+1", name: "United States" },
  { code: "+598", name: "Uruguay" },
  { code: "+998", name: "Uzbekistan" },
  { code: "+678", name: "Vanuatu" },
  { code: "+379", name: "Vatican City" },
  { code: "+58", name: "Venezuela" },
  { code: "+84", name: "Vietnam" },
  { code: "+967", name: "Yemen" },
  { code: "+260", name: "Zambia" },
  { code: "+263", name: "Zimbabwe" },
];
const UserForm = ({
  user,
  updateUser,
  roles,
  submitUser,
  closeModal,
  isEditMode,
}) => {
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);

  // Add this effect to handle initial company_id from company_logins
  useEffect(() => {
    if (user?.company_logins?.length > 0) {
      const companyId = user.company_logins[0].company_id;
      updateUser({ ...user, company_id: [companyId] });
    }
  }, [user?.company_logins]);

  // Add this effect to handle initial country data format
  useEffect(() => {
    if (user?.country) {
      if (typeof user.country === "object" && user.country.code) {
        // If country is an object, format it properly
        const countryData = COUNTRIES.find((c) => c.code === user.country.code);
        const formattedCountry = countryData
          ? `${countryData.name} (${countryData.code})`
          : user.country.code;
        updateUser({ ...user, country: formattedCountry });
      } else if (
        typeof user.country === "string" &&
        !user.country.includes("(")
      ) {
        // If country is just a code string, format it properly
        const countryData = COUNTRIES.find((c) => c.code === user.country);
        if (countryData) {
          const formattedCountry = `${countryData.name} (${countryData.code})`;
          updateUser({ ...user, country: formattedCountry });
        }
      }
    }
  }, [user?.country]);

  // Validation schema
  const UserSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required")
      .min(2, "Name must be at least 2 characters"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().when("$isEditMode", {
      is: false,
      then: (schema) =>
        schema
          .required("Password is required")
          .min(6, "Password must be at least 6 characters"),
      otherwise: (schema) => schema.notRequired(),
    }),
    roles: Yup.string().required("Role is required"),
    company_id: Yup.array().when("roles", {
      is: (val) => {
        const role = roles?.find((r) => r.id === val);
        return role?.title === "Company";
      },
      then: (schema) =>
        schema
          .required("Company is required")
          .min(1, "At least one company must be selected"),
      otherwise: (schema) => schema.notRequired(),
    }),
    city: Yup.string().min(2, "City must be at least 2 characters"),
    country: Yup.string(),
  });

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        setLoading(true);
        const response = await companiesService.getAllCompany();
        setCompanies(response.companies || []);
      } catch (error) {
        console.error("Error fetching companies:", error);
        setCompanies([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  const validateField = async (field, value) => {
    try {
      await UserSchema.validateAt(field, { [field]: value });
      setErrors((prev) => ({ ...prev, [field]: undefined }));
      return true;
    } catch (error) {
      setErrors((prev) => ({ ...prev, [field]: error.message }));
      return false;
    }
  };

  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
    validateField(field, user[field]);
  };

  const handleSubmit = async () => {
    try {
      let dataToSubmit = { ...user }; // Start with a copy of the user object

      // If in edit mode and password is not being updated, remove password from the payload
      if (isEditMode && !user.password) {
        const { password, ...rest } = user;
        dataToSubmit = { ...rest };
      }

      // Ensure company_id and company_logins are always present in the payload
      // And handle the roles property if it's an array of objects
      if (Array.isArray(dataToSubmit.roles) && dataToSubmit.roles.length > 0) {
        dataToSubmit.roles = dataToSubmit.roles[0].id; // Assuming roles is an array of objects with an 'id'
      } else if (Array.isArray(dataToSubmit.roles)) {
        dataToSubmit.roles = null; // Set to null or appropriate default if roles array is empty
      }

      // Explicitly add company_id and company_logins to the payload
      if (user.company_id) {
        dataToSubmit.company_id = user.company_id;
      }
      if (user.company_logins) {
        dataToSubmit.company_logins = user.company_logins;
      }

      // Handle country data - ensure it's in the correct format
      if (user.country) {
        if (typeof user.country === "object" && user.country.code) {
          // If country is an object, format it properly
          const countryData = COUNTRIES.find(
            (c) => c.code === user.country.code,
          );
          dataToSubmit.country = countryData
            ? `${countryData.name} (${countryData.code})`
            : user.country.code;
        } else if (typeof user.country === "string") {
          // If country is already a string, check if it's in the right format
          if (user.country.includes("(") && user.country.includes(")")) {
            // Already in correct format
            dataToSubmit.country = user.country;
          } else {
            // Just a code, convert to full format
            const countryData = COUNTRIES.find((c) => c.code === user.country);
            dataToSubmit.country = countryData
              ? `${countryData.name} (${countryData.code})`
              : user.country;
          }
        }
      }

      await UserSchema.validate(dataToSubmit, {
        abortEarly: false,
        context: { isEditMode },
      });

      submitUser(dataToSubmit);
    } catch (error) {
      const validationErrors = {};
      if (error.inner && Array.isArray(error.inner)) {
        error.inner.forEach((err) => {
          if (err.path) {
            validationErrors[err.path] = err.message;
          }
        });
      } else {
        // Handle non-validation errors

        validationErrors.general =
          "An error occurred while submitting the form";
      }
      setErrors(validationErrors);
      // Mark all fields as touched to show errors
      const touchedFields = {};
      Object.keys(validationErrors).forEach((field) => {
        touchedFields[field] = true;
      });
      setTouched(touchedFields);
    }
  };

  return (
    <>
      <div className="bg-card p-6 rounded-lg w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">
          {user?.id ? "Edit User" : "Add User"}
        </h2>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Name"
              value={user.name || ""}
              onChange={(e) => {
                updateUser({ ...user, name: e.target.value });
                if (touched.name) {
                  validateField("name", e.target.value);
                }
              }}
              onBlur={() => handleBlur("name")}
              className={`border rounded-lg p-2 w-full ${touched.name && errors.name ? "border-red-500" : ""}`}
            />
            {touched.name && errors.name && (
              <p className="text-red-500 text-sm mt-1">{errors.name}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              placeholder="Email"
              value={user.email}
              disabled={isEditMode}
              onChange={(e) => {
                updateUser({ ...user, email: e.target.value });
                if (touched.email) {
                  validateField("email", e.target.value);
                }
              }}
              onBlur={() => handleBlur("email")}
              className={`border rounded-lg p-2 w-full mb-4 ${touched.email && errors.email ? "border-red-500" : ""}`}
            />
            {touched.email && errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Password {!isEditMode && <span className="text-red-500">*</span>}
            </label>
            <input
              type="password"
              placeholder="Password"
              value={isEditMode ? "" : user.password || ""}
              onChange={(e) => {
                updateUser({ ...user, password: e.target.value });
                if (touched.password) {
                  validateField("password", e.target.value);
                }
              }}
              onBlur={() => handleBlur("password")}
              className={`border rounded-lg p-2 w-full ${touched.password && errors.password ? "border-red-500" : ""}`}
            />
            {touched.password && errors.password && (
              <p className="text-red-500 text-sm mt-1">{errors.password}</p>
            )}
          </div>

          {/* Role dropdown */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Role <span className="text-red-500">*</span>
            </label>
            <div>
              <Dropdown
                options={roles.map((role) => ({
                  label:
                    role.title === "Company_admin"
                      ? "Company Admin"
                      : role.title === "Company"
                        ? "Client Dashboard Only"
                        : role.title,
                  value: role.id,
                }))}
                value={
                  user.roles
                    ? {
                        label:
                          roles.find((r) => r.id === user.roles)?.title ===
                          "Company_admin"
                            ? "Company Admin"
                            : roles.find((r) => r.id === user.roles)?.title ===
                                "Company"
                              ? "Client Dashboard Only"
                              : roles.find((r) => r.id === user.roles)?.title,
                        value: user.roles,
                      }
                    : null
                }
                onChange={(selected) => {
                  const newValue = selected?.value || "";
                  updateUser({ ...user, roles: newValue, company_id: [] });
                  if (touched.roles) {
                    validateField("roles", newValue);
                  }
                }}
                onBlur={() => handleBlur("roles")}
                placeholder="Select Role"
                icon={<Building className="w-5 h-5 text-foreground flex-shrink-0" />}
                searchable={true}
                triggerClassName={` rounded-lg ${touched.roles && errors.roles ? "border-red-500" : ""}`}
                style={{ backgroundColor: "rgb(245 249 247)" }}
                renderOption={(option) => (
                  <p className="text-foreground">{option.label}</p>
                )}
              />
              {touched.roles && errors.roles && (
                <p className="text-red-500 text-sm mt-1">{errors.roles}</p>
              )}
            </div>
          </div>

          {/* company dropdown */}
          {roles.find((r) => r.id === user.roles)?.title === "Company" && (
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Company <span className="text-red-500">*</span>
              </label>
              <div>
                <Dropdown
                  options={companies.map((company) => ({
                    label: company.name,
                    value: company.id,
                  }))}
                  value={
                    user.company_id && user.company_id.length > 0
                      ? companies.find((c) => c.id === user.company_id[0])
                        ? {
                            label:
                              companies.find((c) => c.id === user.company_id[0])
                                ?.name || "",
                            value: user.company_id[0],
                          }
                        : null
                      : null
                  }
                  onChange={(selected) => {
                    const newValue = selected?.value ? [selected.value] : [];
                    updateUser({
                      ...user,
                      company_id: newValue,
                      company_logins:
                        newValue.length > 0
                          ? [
                              {
                                company_id: newValue[0],
                                user_id: user.id,
                              },
                            ]
                          : [],
                    });
                    if (touched.company_id) {
                      validateField("company_id", newValue);
                    }
                  }}
                  onBlur={() => handleBlur("company_id")}
                  icon={
                    <Building className="w-5 h-5 text-foreground flex-shrink-0" />
                  }
                  searchable={true}
                  triggerClassName={`rounded-lg ${touched.company_id && errors.company_id ? "border-red-500" : ""}`}
                  style={{ backgroundColor: "rgb(245 249 247)" }}
                  renderOption={(option) => (
                    <p className="text-foreground">{option.label}</p>
                  )}
                  disabled={loading}
                />
                {touched.company_id && errors.company_id && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.company_id}
                  </p>
                )}
              </div>
            </div>
          )}

          {/* color */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Colour
            </label>
            <input
              type="color"
              value={user.color || "#ffffff"}
              onChange={(e) => updateUser({ ...user, color: e.target.value })}
              className="border rounded-lg p-1 w-full h-10"
            />
          </div>
          {/* Recruiter location group */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-foreground mb-1">
              Recruiter location
            </label>
            <div className="flex flex-col gap-2">
              <input
                type="text"
                placeholder="City"
                value={user.city || ""}
                onChange={(e) => {
                  updateUser({ ...user, city: e.target.value });
                  if (touched.city) {
                    validateField("city", e.target.value);
                  }
                }}
                onBlur={() => handleBlur("city")}
                className={`border rounded-lg p-2 w-full ${touched.city && errors.city ? "border-red-500" : ""}`}
              />
              <Dropdown
                options={COUNTRIES.map((country) => ({
                  label: `${country.name} (${country.code})`,
                  value: country.code,
                }))}
                value={
                  user.country
                    ? {
                        label: `${COUNTRIES.find((c) => c.code === user.country)?.name || ""} (${user.country})`,
                        value: user.country,
                      }
                    : null
                }
                onChange={(selected) => {
                  const countryValue = selected?.value
                    ? `${COUNTRIES.find((c) => c.code === selected.value)?.name} (${selected.value})`
                    : "";
                  updateUser({ ...user, country: countryValue });
                  if (touched.country) {
                    validateField("country", countryValue);
                  }
                }}
                onBlur={() => handleBlur("country")}
                placeholder="Select Country"
                icon={<Globe className="w-5 h-5 text-foreground flex-shrink-0" />}
                searchable={true}
                triggerClassName={` rounded-lg ${touched.country && errors.country ? "border-red-500" : ""}`}
                style={{ backgroundColor: "rgb(245 249 247)" }}
                renderOption={(option) => (
                  <p className="text-foreground">{option.label}</p>
                )}
              />
            </div>
            {touched.city && errors.city && (
              <p className="text-red-500 text-sm mt-1">{errors.city}</p>
            )}
            {touched.country && errors.country && (
              <p className="text-red-500 text-sm mt-1">{errors.country}</p>
            )}
          </div>

          <div className="flex justify-end mt-6">
            <button
              onClick={() => {
                updateUser({
                  name: "",
                  email: "",
                  roles: "",
                  password: "",
                  color: "#ffffff",
                  city: "",
                  country: "",
                });
                closeModal();
              }}
              className="bg-muted-foreground text-white px-4 py-2 rounded-lg mr-2 hover:bg-muted-foreground"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="bg-primary-dark text-white px-4 py-2 rounded-lg hover:bg-primary-dark transition-colors"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserForm;
